import React from "react";
import { MessageStrip as UI5MessageStrip } from "@ui5/webcomponents-react";
import { cn } from "../../../lib/cn";

export function MessageStrip({
  className,
  design = "Information",
  hideCloseButton = false,
  hideIcon = false,
  onClose,
  children,
  ...props
}) {
  return (
    <UI5MessageStrip
      design={design}
      hideCloseButton={hideCloseButton}
      hideIcon={hideIcon}
      onClose={onClose}
      className={cn(
        "w-full", // Full width by default
        className
      )}
      {...props}
    >
      {children}
    </UI5MessageStrip>
  );
}

/**
 * Design types:
 * - 'Information': Blue info message (default)
 * - 'Positive': Green success message
 * - 'Negative': Red error message
 * - 'Warning': Orange warning message
 */
